import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { useAppLiveQuery } from "@modules/local/hooks";
import { db } from "@modules/local/db";

import { useB2B } from "@modules/content/B2BContext";
import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";
import { useAppSelector } from "@lib/stores";
import { setStorageSyncIfNull } from "@modules/storage/storageHelper";

export const requireAuth = (Children: JSX.Element) => {
  const RenderChildren = () => {
    const navigate = useAppNavigate();
    const { pathname, search } = useLocation();
    const currentUrl = pathname + search;

    const isB2b = getQueryFromUrl("b2b") === "1";

    const isAuthenticated = useAppSelector(({ auth }) =>
      Boolean(auth.tokens?.token)
    );
    const {
      onboardingCompleted,
      b2BOnboardingCompleted,
      id: userId,
    } = useAppSelector(({ auth }) => auth.user ?? {});

    const isContentPrepareLoading = useAppSelector(
      ({ auth }) => auth.isContentPrepareLoading
    );

    const { result: flow } = useAppLiveQuery(
      () => db.readerFlows.get(userId ?? ""),
      [userId]
    );

    const { b2B } = useB2B();

    useEffect(() => {
      setStorageSyncIfNull({
        key: "INIT_URL",
        data: currentUrl,
      });

      if (!isAuthenticated) {
        console.log("requireAuth", pathname);

        if (isB2b) {
          return navigate(`/login/b2b`, undefined, {
            replace: true,
            state: { from: currentUrl },
          });
        }

        return navigate(`/login`, undefined, {
          replace: true,
          state: { from: currentUrl },
        });
      }

      if (!flow?.id || !b2B) return;

      if (
        b2B?.isB2B === false &&
        !onboardingCompleted &&
        pathname !== "/onboarding"
      ) {
        // curry the return url to the onboarding page
        return navigate(`/onboarding`, undefined, {
          replace: true,
          state: { from: currentUrl },
        });
      }

      if (b2B?.isB2B && !b2BOnboardingCompleted) {
        // TODO: renable after doing the b2b onboarding
        // return navigate(`/onboarding-b2b`, undefined, {
        //   replace: true,
        //   state: { from: currentUrl },
        // })
      }
    }, [
      onboardingCompleted,
      b2BOnboardingCompleted,
      isAuthenticated,
      navigate,
      pathname,
      search,
      isB2b,
      // flow?.isB2B,
      flow?.id,
      isContentPrepareLoading,
      b2B?.isB2B,
    ]);

    return isAuthenticated ? Children : null;
  };

  return <RenderChildren />;
};
